<span class="fa fa-exclamation-circle" *ngIf="showIcon"></span>
<ng-content></ng-content>
